import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { AuthService } from './services/auth.service';
import { HomeLayoutComponent } from '../layouts/home-layout/home-layout.component';
import { LoginLayoutComponent } from '../layouts/login-layout/login-layout.component';
import { HomeComponent } from '../learn/home/home.component';
import { PageNotFoundComponent } from '../learn/view/page-not-found/page-not-found.component';
import { SharedModule } from 'primeng/primeng';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRightPanelComponent } from '../app.rightpanel.component';
import { AppMenuComponent, AppSubMenuComponent } from '../app.menu.component';
import { AppBreadcrumbComponent } from '../app.breadcrumb.component';
import { AppTopBarComponent } from '../app.topbar.component';
import { AppFooterComponent } from '../app.footer.component';
import { AuthGaurd } from './services/auth-gaurd.service';

@NgModule({
  imports: [
    CommonModule, PrimengModule,
    SharedModule, FormsModule, ReactiveFormsModule
  ], providers: [AuthService, AuthGaurd],
  declarations: [LoginComponent, HomeLayoutComponent, LoginLayoutComponent, HomeComponent, PageNotFoundComponent, AppRightPanelComponent,
    AppMenuComponent,
    AppSubMenuComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppFooterComponent,]


})
export class LoginModule { }
